import React from 'react';
import { StarsText } from './Stars';

/**
 * `.avis` — carte d'avis client.
 *
 * Deux habillages, pilotés par le contexte et non par une prop : sur fond vert
 * la maquette utilise un verre dépoli translucide, dans l'onglet Avis un encadré
 * blanc à ombre franche (`.salon-tab-panel .avis`). Le composant est le même.
 *
 * Les étoiles sont un `<div>` : c'est l'élément de la maquette dans les deux
 * contextes (détail 294-309, listing 349-364), et il faut du block pour que le
 * `margin-bottom: 7px` de `.avis .stars` s'applique.
 */
const ReviewCard = ({ rating, content, sender }) => (
  <div className="avis">
    <StarsText rating={rating} className="stars" as="div" />
    <p>« {content} »</p>
    {sender && <div className="who">{sender}</div>}
  </div>
);

export default ReviewCard;
